export default __webpack_public_path__ + "static/media/question-card.a1601b1f.png";